import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectStripe } from "react-stripe-elements";
import { openModal, proceedWithCheckout } from "../../redux/actions";

const mapStateToProps = state => ({
  userData: state.user.userData,
  status: state.payment.status,
  error: state.payment.error,
  payingWith: state.userPreferences.payingWith,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleCheckout: proceedWithCheckout,
  handleLoginButtonClick: openModal,
}, dispatch);

@injectStripe
@connect(mapStateToProps, mapDispatchToProps)
class PaymentForm extends Component {
  static propTypes = {
    handlePaymentMethodSelection: PropTypes.func,
    handleCheckout: PropTypes.func,
    handleLoginButtonClick: PropTypes.func,
    stripe: PropTypes.instanceOf(Object),
    userData: PropTypes.instanceOf(Object),
    payingWith: PropTypes.instanceOf(Object),
    status: PropTypes.string,
    error: PropTypes.string,
    children: PropTypes.node,
  };

  state = {
    brand: '',
    cardErrors: {
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      postalCode: null,
    },
    cardNumber: null,
    cardExpiry: null,
    cardCvc: null,
    postalCode: null,
  };

  setUpFieldInstances = (number, expiry, cvc, postal) => {
    this.setState({
      cardNumber: number,
      cardExpiry: expiry,
      cardCvc: cvc,
      postalCode: postal,
    })
  };

  handlePaymentMethodClick = evt => {
    const { handlePaymentMethodSelection } = this.props;
    const { target } = evt;
    const { value } = target;

    handlePaymentMethodSelection(value);
  };

  getNextStripeElement = elType => {
    switch (elType) {
      case 'cardNumber':
        return 'cardExpiry';
      case 'cardExpiry':
        return 'cardCvc';
      case 'cardCvc':
        return 'postalCode';
      case 'postalCode':
        return null;

      default:
        return null;
    }
  };

  handleCardElementsInput = value => {
    const { getNextStripeElement } = this;
    const { brand, error, elementType, complete } = value;
    const { brand: stateBrand } = this.state;

    this.setState(prevState => ({
      cardErrors: {
        ...prevState.cardErrors,
        [elementType]: error ? error.message : null,
      },
    }));

    if (complete && !error && elementType !== 'postalCode' && !(elementType === 'cardCvc' && stateBrand === 'amex')) {
      const nextRef = getNextStripeElement(elementType);
      // eslint-disable-next-line
      this.state[nextRef]._element.focus();
    }

    if (brand) {
      this.setState({
        brand,
      });
    }
  };

  handleFormSubmit = (values, type) => {
    const { stripe, handleCheckout, payingWith } = this.props;

    handleCheckout(stripe, values, payingWith, type);
  };

  render() {
    const { handlePaymentMethodClick, handleCardElementsInput, handleFormSubmit, setUpFieldInstances } = this;
    const { brand, cardErrors } = this.state;
    const { children, handleCheckout, handleLoginButtonClick, userData, status, error, payingWith } = this.props;

    const baseScheme = {
      firstName: Yup.string().required('First name is required').nullable(),
      lastName: Yup.string().required('Last name is required').nullable(),
      emailAddress: Yup.string().email('Invalid email').required('Email is required').nullable(),
      phone: Yup.string().required('Phone is required').nullable(),
    };

    const baseInitialValues = userData ? {
      firstName: userData.firstName,
      lastName: userData.lastName,
      emailAddress: userData.emailAddress,
      phone: userData.phone,
      cardId: null,
    } : {
      firstName: null,
      lastName: null,
      emailAddress: null,
      phone: null,
      cardId: null,
    };

    return React.Children.map(children, child => cloneElement(child, {
      handlePaymentMethodClick,
      handleCardElementsInput,
      handleFormSubmit,
      setUpFieldInstances,
      handleCheckout,
      handleLoginButtonClick,
      brand,
      cardErrors,
      userData,
      status,
      baseScheme,
      baseInitialValues,
      error,
      payingWith,
    }));
  }
}

export default PaymentForm;
